// Helpers for the sc-142143 A/B experiment that hides the enable count on
// applet cards for half of web users. Cohort + flag are populated by the
// Rails layout via _js_context.html.erb on in-scope pages; off-scope pages,
// XHR responses without the layout, and bootstrap-time reads return safe
// defaults (cohort "", hide false) so the count renders as today.

export const shouldHideInstallsCount = (): boolean =>
  Boolean((window as any).App?.hideInstallsCount)

export const getEnableCountCohort = (): string =>
  (window as any).App?.enableCountCohort ?? ""
